import { useEffect, useMemo } from "react";

/**
 * File ที่ผู้ใช้เลือก (ยังไม่ส่ง) → [{ src, name }] สำหรับโชว์ภาพย่อ/เปิดดูเต็มจอ
 * สร้าง blob URL ครั้งเดียวต่อชุดไฟล์ และคืนหน่วยความจำเมื่อไฟล์เปลี่ยนหรือปิดหน้า
 */
export default function useFilePreviews(files) {
  const previews = useMemo(
    () => (files || []).map((file) => ({ src: URL.createObjectURL(file), name: file.name })),
    [files]
  );

  useEffect(
    () => () => previews.forEach((p) => URL.revokeObjectURL(p.src)),
    [previews]
  );

  return previews;
}
